// import { Link } from "@/i18n/routing"
import styles from "./Breadcrumbs.module.scss"
import { useTranslations } from "next-intl"

export default function Breadcrumbs({ items, home, className = "" }) {
  const t = useTranslations()

  return (
    <div className={`${styles.breadcrumbs} ${className}`}>
      <a
        href="/"
        className={`${styles.breadcrumbs__item} ${styles.breadcrumbs__item_home}`}
      >
        {home || t("breadcrumbs.home")}
      </a>
      {items.map((el, index) => {
        return el.link ? (
          <a
            key={index}
            href={el.link}
            className={`${styles.breadcrumbs__item} ${styles.breadcrumbs__item_page}`}
          >
            {el.name}
          </a>
        ) : (
          <span
            key={index}
            className={`${styles.breadcrumbs__item} ${styles.breadcrumbs__item_page}`}
          >
            <span>{el.name}</span>
          </span>
        )
      })}
    </div>
  )
}
